/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "designer",
            "endpoint": "https://7q1g9kc536.execute-api.us-west-2.amazonaws.com/prod",
            "region": "us-west-2"
        },
        {
            "name": "androidApi",
            "endpoint": "https://gat9rczf7f.execute-api.us-west-2.amazonaws.com/prod",
            "region": "us-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "us-west-2:3a919131-5dbb-4a88-9bf4-58d08c94dff6",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_umdDnWobv",
    "aws_user_pools_web_client_id": "2pbejk3m7601seceutk879od7r",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "firststep-ai-designer03520-prod",
    "aws_user_files_s3_bucket_region": "us-west-2"
};


export default awsmobile;
